import { useApi } from '@/api';
import { Page, PageSkeleton } from '@/components';
import { Flex, Heading, useTableProps } from '@blockanalitica/ui';
import TokenEventsTable from './EventsTable';

export default function TokenActivityPage() {
  const { pagination, sorting } = useTableProps({
    pageSize: 20,
    initialSorting: '-order_index',
    filtersDebounceTime: 50
  });
  const [data, error] = useApi({
    url: `/arbitrum/psm3/swap-events/`,
    queryParams: {
      p: pagination.currentPage,
      p_size: pagination.pageSize,
      order: sorting.currentSorting
    }
  });

  if (error) {
    throw error;
  }

  if (data) {
    return (
      <Page
        title={
          <Heading size="1">
            <Flex
              flexBasis="100%"
              gap={['xs', '2xs']}
              flexDirection={['column', 'row']}>
              PSM 3 Swap Activity
            </Flex>
          </Heading>
        }>
        <TokenEventsTable
          pagination={pagination}
          sorting={sorting}
          data={data}
        />
      </Page>
    );
  }

  return <PageSkeleton />;
}
